import { salesOrderLineChangesInputSchema } from './line-change-set-input.js';
/** Review Changes' form: the API's own reason rule, so the cap, trim and blank-as-none match. */
export const salesOrderLineChangesReviewFormSchema = salesOrderLineChangesInputSchema.pick({
    reason: true,
});
export const SALES_ORDER_LINE_CHANGES_REVIEW_FORM_DEFAULTS = {
    reason: '',
};
//# sourceMappingURL=line-changes-review-form.js.map